import React, { useEffect, useState } from "react";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 w-[320px] bg-white text-black p-5 rounded-2xl shadow-xl border border-gray-200 animate-slide-up z-50 font-[Poppins]">
      {/* Titre */}
      <h2 className="text-lg font-medium text-color1 mb-2">
        Utilisation des cookies
      </h2>

      {/* Texte */}
      <p className="text-sm mb-4">
        Ce site utilise des cookies, y compris ceux de Google, afin
        d’améliorer votre expérience et analyser le trafic.
      </p>

      {/* Bouton */}
      <button
        onClick={acceptCookies}
        className="bg-color1 hover:bg-color1/90 text-white text-sm font-semibold px-5 py-2 rounded-lg transition"
      >
        Accepter
      </button>
    </div>
  );
};

export default CookieConsent;
